export const Api = {
    base: process.env.REACT_APP_API as string,
    folder: '/folder',
    projectFolders: (id: string) => `/project/${id}/folder`,
    projectImage: (id: string) => `/project/${id}/image`,
    projectImageUpload: (id: string) => `/project/${id}/image/upload`,
};
